import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=6213e82f&scoped=true&lang=html"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"
import style0 from "./GenericModal.css?vue&type=style&index=0&id=6213e82f&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213e82f",
  null
  
)

export default component.exports